var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-md-12 mb-2"},[(_vm.mode === 'paragraph')?_c('TabQuoteDetailsDescription',{attrs:{"data-obj":_vm.dataObj}}):_c('TabQuoteDetailsList',{attrs:{"data-obj":_vm.dataObj}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }